// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--spacing-xxs: 2px;--spacing-xs: 4px;--spacing-s: 8px;--spacing-m: 12px;--spacing-l: 16px;--spacing-xl: 24px;--spacing-xxl: 32px;--spacing-xxl-2: 40px;--spacing-xxl-3: 48px;--spacing-xxl-4: 56px;--spacing-xxl-5: 64px;--spacing-xxl-6: 80px}.b2b-lib-click_to_call_error_view{text-align:center;margin:auto}.b2b-lib-click_to_call_error_view img{margin-bottom:var(--spacing-l)}.b2b-lib-click_to_call_error_view .b2b-lib-text{font-weight:600;font-size:20px;color:#0c0f12;line-height:1.5}@media only screen and (max-width: 767px){.b2b-lib-click_to_call_error_view .b2b-lib-text{font-size:14px}}\n", ""]);
// Exports
exports.locals = {
	"click_to_call_error_view": "b2b-lib-click_to_call_error_view",
	"text": "b2b-lib-text"
};
module.exports = exports;
